import * as React from "react";
import type { SVGProps } from "react";
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.754 12.149 1.771 7.969c.221.993 1.54 1.207 2.063.335l8.249-13.749A1.124 1.124 0 0 0 19.873 5H4.322c-1.003 0-1.505 1.212-.796 1.921z"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.84 5.56 8.75 12.15"
    />
  </svg>
);
export default SvgSend;
